import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "./Reveal";

const CTA = ({ title = "Have you a project you want delivered?", text, testid = "cta-section" }) => (
  <section data-testid={testid} className="relative border-t border-zinc-800/60 blueprint-grid overflow-hidden">
    <div className="max-w-7xl mx-auto px-6 py-24 sm:py-28 flex flex-col lg:flex-row lg:items-end lg:justify-between gap-10">
      <Reveal>
        <p className="text-xs font-mono uppercase tracking-[0.3em] text-zinc-500">Start the conversation</p>
        <h2 className="mt-5 font-display text-2xl sm:text-3xl lg:text-4xl font-bold uppercase tracking-tight text-zinc-100 max-w-xl leading-tight">
          {title}
        </h2>
        {text && <p className="mt-5 max-w-lg text-sm text-zinc-400 font-light leading-relaxed">{text}</p>}
      </Reveal>
      <Reveal delay={0.15}>
        <Link
          to="/contact"
          data-testid="cta-contact-button"
          className="group inline-flex items-center gap-3 bg-zinc-50 text-zinc-950 px-8 py-4 font-mono text-xs uppercase tracking-[0.2em] hover:bg-[#C5A059] transition-colors duration-300"
        >
          Book a consultation
          <ArrowUpRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" />
        </Link>
      </Reveal>
    </div>
  </section>
);

export default CTA;
